import SignupForm from "@/components/signup-form";
import MobileSignupForm from "@/components/mobile-signup-form";
import { AuthCanvas } from "@/components/auth-canvas";

// 帳戶註冊页：完全沿用登录页 1920×1080 画布壳（AuthCanvas），右侧表单换成 SignupForm。
function SignupPage() {
  return (
    <AuthCanvas
      renderDesktopForm={() => <SignupForm />}
      renderMobileForm={() => <MobileSignupForm />}
    />
  );
}

export default SignupPage;
